import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../css/SideMenu.css';

function SideMenu({ isOpen, onClose }) {
    const { isAdmin } = useAuth();

    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose]);

    return (
        <>
            {isOpen && (
                <div
                    className="side-menu-backdrop"
                    onClick={onClose}
                    aria-hidden="true"
                />
            )}
            <div
                className={`side-menu ${isOpen ? 'open' : ''}`}
                role="navigation"
                aria-hidden={!isOpen}
            >
                <ul>
                    <li><Link to="/" onClick={onClose}>🏠 Início</Link></li>
                    <li><Link to="/create" onClick={onClose}>➕ Criar Sala</Link></li>
                    <li><Link to="/join" onClick={onClose}>🔑 Entrar em Sala</Link></li>
                    {isAdmin && (
                        <li><Link to="/admin" onClick={onClose}>⚙️ Administração</Link></li>
                    )}
                    <li><Link to="/recursos" onClick={onClose}>📑 Recursos e artigos</Link></li>
                    <li><Link to="/guia" onClick={onClose}>📚 Guia Planning Poker</Link></li>
                    <li><Link to="/sobre" onClick={onClose}>📄 Sobre</Link></li>
                    <li><Link to="/faq" onClick={onClose}>❓ FAQ</Link></li>
                    <li><Link to="/privacidade" onClick={onClose}>😶 Política de Privacidade</Link></li>
                </ul>
            </div>
        </>
    );
}

export default SideMenu;
